import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, withCtx as _withCtx, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/../public/assets/img/thingTag_taggen.svg'


const _withScopeId = n => (_pushScopeId("data-v-443b2e54"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "sidemenu-opener" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", null, [
  /*#__PURE__*/_createElementVNode("img", {
    width: "38",
    src: _imports_0
  }),
  /*#__PURE__*/_createTextVNode(" Tag ")
], -1))
const _hoisted_3 = ["title"]
const _hoisted_4 = ["title"]
const _hoisted_5 = ["title"]
const _hoisted_6 = ["title"]
const _hoisted_7 = ["title"]
const _hoisted_8 = ["title"]
const _hoisted_9 = ["title"]
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("title", null, "Here", -1))
const _hoisted_11 = ["title"]
const _hoisted_12 = ["title"]
const _hoisted_13 = ["title"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_ripple_effect = _resolveComponent("ion-ripple-effect")!
  const _component_ion_alert = _resolveComponent("ion-alert")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      id: "sidemenu",
      class: _normalizeClass({open: $setup.isOpen})
    }, [
      _createElementVNode("ul", null, [
        _createElementVNode("li", _hoisted_1, [
          _createElementVNode("a", {
            class: "ion-activatable ripple-parent",
            title: "Menü auf/zu",
            onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.toggleSideMenu()))
          }, [
            _createVNode(_component_ion_icon, {
              icon: $setup.isOpen ? $setup.chevronForwardOutline : $setup.chevronBackOutline
            }, null, 8, ["icon"])
          ]),
          _createVNode(_component_ion_ripple_effect)
        ]),
        ($props.showTagObject > 0)
          ? (_openBlock(), _createElementBlock("li", {
              key: 0,
              title: "Tag",
              onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.tagObject(_ctx.objectId))),
              class: "ion-activatable ripple-parent"
            }, [
              _hoisted_2,
              _createVNode(_component_ion_ripple_effect)
            ]))
          : _createCommentVNode("", true),
        ($props.showSaveTag)
          ? (_openBlock(), _createElementBlock("li", {
              key: 1,
              class: _normalizeClass([{'disabled': $props.disableSave}, "green ion-activatable ripple-parent"]),
              title: _ctx.$t('message.saveTag'),
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => ($setup.saveTag && $setup.saveTag(...args)))
            }, [
              _createElementVNode("a", null, [
                _createVNode(_component_ion_icon, { icon: $setup.checkmarkOutline }, null, 8, ["icon"]),
                _createTextVNode(" " + _toDisplayString(_ctx.$t("message.saveTag")), 1)
              ]),
              _createVNode(_component_ion_ripple_effect)
            ], 10, _hoisted_3))
          : _createCommentVNode("", true),
        ($props.showReset)
          ? (_openBlock(), _createElementBlock("li", {
              key: 2,
              title: _ctx.$t('message.reset'),
              onClick: _cache[3] || (_cache[3] = ($event: any) => ($setup.reset())),
              class: "ion-activatable ripple-parent"
            }, [
              _createElementVNode("a", null, [
                _createVNode(_component_ion_icon, { icon: $setup.refreshOutline }, null, 8, ["icon"]),
                _createTextVNode(" " + _toDisplayString(_ctx.$t("message.reset")), 1)
              ]),
              _createVNode(_component_ion_ripple_effect)
            ], 8, _hoisted_4))
          : _createCommentVNode("", true),
        ($props.showHints)
          ? (_openBlock(), _createElementBlock("li", {
              key: 3,
              title: _ctx.$t('message.tipps'),
              onClick: _cache[4] || (_cache[4] = ($event: any) => ($setup.displayHints())),
              class: "ion-activatable ripple-parent"
            }, [
              _createElementVNode("a", null, [
                _createVNode(_component_ion_icon, { icon: $setup.bulbOutline }, null, 8, ["icon"]),
                _createTextVNode(" " + _toDisplayString(_ctx.$t("message.tipps")), 1)
              ]),
              _createVNode(_component_ion_ripple_effect)
            ], 8, _hoisted_5))
          : _createCommentVNode("", true),
        ($props.showWorkInfo)
          ? (_openBlock(), _createElementBlock("li", {
              key: 4,
              title: _ctx.$t('message.imageInfo'),
              onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => ($setup.displayWorkInfo && $setup.displayWorkInfo(...args))),
              class: "ion-activatable ripple-parent"
            }, [
              _createElementVNode("a", null, [
                _createVNode(_component_ion_icon, { icon: $setup.informationOutline }, null, 8, ["icon"]),
                _createTextVNode(" " + _toDisplayString(_ctx.$t("message.imageInfo")), 1)
              ]),
              _createVNode(_component_ion_ripple_effect)
            ], 8, _hoisted_6))
          : _createCommentVNode("", true),
        ($props.showNextWork)
          ? (_openBlock(), _createElementBlock("li", {
              key: 5,
              title: _ctx.$t('message.next'),
              onClick: _cache[6] || (_cache[6] = ($event: any) => ($setup.nextWork())),
              class: "ion-activatable ripple-parent"
            }, [
              _createElementVNode("a", null, [
                _createVNode(_component_ion_icon, { icon: $setup.arrowForwardOutline }, null, 8, ["icon"]),
                _createTextVNode(" " + _toDisplayString(_ctx.$t("message.next")), 1)
              ]),
              _createVNode(_component_ion_ripple_effect)
            ], 8, _hoisted_7))
          : _createCommentVNode("", true),
        ($props.showSkipObject)
          ? (_openBlock(), _createElementBlock("li", {
              key: 6,
              title: _ctx.$t('message.chooseAnotherObjext'),
              onClick: _cache[7] || (_cache[7] = ($event: any) => ($setup.skipObject())),
              class: "ion-activatable ripple-parent"
            }, [
              _createElementVNode("a", null, [
                _createVNode(_component_ion_icon, { icon: $setup.cubeOutline }, null, 8, ["icon"]),
                _createTextVNode(" " + _toDisplayString(_ctx.$t("message.chooseAnotherObjext")), 1)
              ]),
              _createVNode(_component_ion_ripple_effect)
            ], 8, _hoisted_8))
          : _createCommentVNode("", true),
        ($props.finishTagging)
          ? (_openBlock(), _createElementBlock("li", {
              key: 7,
              title: _ctx.$t('message.finishTagging'),
              onClick: _cache[8] || (_cache[8] = ($event: any) => ($setup.setAlertOpen(true))),
              class: "ion-activatable ripple-parent"
            }, [
              _createElementVNode("a", null, [
                _createVNode(_component_ion_icon, { icon: $setup.closeOutline }, {
                  default: _withCtx(() => [
                    _hoisted_10
                  ]),
                  _: 1
                }, 8, ["icon"]),
                _createTextVNode(" " + _toDisplayString(_ctx.$t("message.finishTagging")), 1)
              ]),
              _createVNode(_component_ion_ripple_effect)
            ], 8, _hoisted_9))
          : _createCommentVNode("", true),
        ($props.showMoreInfo)
          ? (_openBlock(), _createElementBlock("li", {
              key: 8,
              title: _ctx.$t('message.moreInfo'),
              onClick: _cache[9] || (_cache[9] = ($event: any) => ($setup.goToLongText())),
              class: "ion-activatable ripple-parent"
            }, [
              _createElementVNode("a", null, [
                _createVNode(_component_ion_icon, { icon: $setup.documentText }, null, 8, ["icon"]),
                _createTextVNode(" " + _toDisplayString(_ctx.$t("message.moreInfo")), 1)
              ]),
              _createVNode(_component_ion_ripple_effect)
            ], 8, _hoisted_11))
          : _createCommentVNode("", true),
        ($props.showDismiss)
          ? (_openBlock(), _createElementBlock("li", {
              key: 9,
              title: _ctx.$t('message.gotagging'),
              onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.$parent.dismiss())),
              class: "ion-activatable ripple-parent"
            }, [
              _createElementVNode("a", null, [
                _createVNode(_component_ion_icon, { icon: $setup.checkmarkOutline }, null, 8, ["icon"]),
                _createTextVNode(" " + _toDisplayString(_ctx.$t("message.gotagging")), 1)
              ]),
              _createVNode(_component_ion_ripple_effect)
            ], 8, _hoisted_12))
          : _createCommentVNode("", true),
        ($props.showGoBack)
          ? (_openBlock(), _createElementBlock("li", {
              key: 10,
              title: _ctx.$t('message.back'),
              onClick: _cache[11] || (_cache[11] = ($event: any) => ($setup.goBack())),
              class: "ion-activatable ripple-parent"
            }, [
              _createElementVNode("a", null, [
                _createVNode(_component_ion_icon, { icon: $setup.arrowBackOutline }, null, 8, ["icon"]),
                _createTextVNode(" " + _toDisplayString(_ctx.$t('message.back')), 1)
              ]),
              _createVNode(_component_ion_ripple_effect)
            ], 8, _hoisted_13))
          : _createCommentVNode("", true)
      ])
    ], 2),
    _createVNode(_component_ion_alert, {
      "is-open": $setup.isAlertOpen,
      header: "Taggen beenden",
      message: "Wollen Sie das Taggen wirklich beenden? Bisherige Punkte bleiben erhalten.",
      "css-class": "tagging-finish-alert",
      buttons: $setup.alertButtons,
      onDidDismiss: _cache[12] || (_cache[12] = ($event: any) => ($setup.setAlertOpen(false)))
    }, null, 8, ["is-open", "buttons"])
  ], 64))
}